export default __webpack_public_path__ + "static/media/pink-drag.49da15a8.png";